import { render } from "./SupportRequestFilter.vue?vue&type=template&id=04a0a394&scoped=true&ts=true"
import script from "./SupportRequestFilter.vue?vue&type=script&lang=ts"
export * from "./SupportRequestFilter.vue?vue&type=script&lang=ts"

import "./SupportRequestFilter.vue?vue&type=style&index=0&id=04a0a394&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04a0a394"]])

export default __exports__